import {
  Button,
  Divider,
  FileInput,
  FormGroup,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { api } from "../../api";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
import PhoneNumberInput from "../utils/PhoneNumberInput";

interface EmpresaPgdasProps {
  handlesDownloadpgdas: () => void;
  receita_bruta: string;
  cod_acesso: string;
  haldleDisableValidSimples: () => void;
  handleReceitaBrutaValid: (vl: string) => void;
  handleCodAcesso: (vl: string) => void;
}

interface EmpresaPgdasState {
  handlesDownloadpgdas: () => void;
  receita_bruta: string;
  cod_acesso: string;
  haldleDisableValidSimples: () => void;
  handleReceitaBrutaValid: (vl: string) => void;
  handleCodAcesso: (vl: string) => void;
  selectedAnexo: string
  send_das: boolean
  send_pgdas: boolean
  indicadorComparacao: boolean
}

@observer
export default class EmpresaPgdas extends React.Component<EmpresaPgdasProps, EmpresaPgdasState> {

  obs = observable({
    validando: false as boolean,
    nome_certificado: "Selecione um arquivo" as string,
    open_ajuda: false as boolean,
    max_number_pgdas: 2 as number
  })

  constructor(props) {
    super(props);

    this.state = {
      handlesDownloadpgdas: props.handlesDownloadpgdas,
      receita_bruta: props.receita_bruta,
      haldleDisableValidSimples: props.haldleDisableValidSimples,

      handleReceitaBrutaValid: props.handleReceitaBrutaValid,
      cod_acesso: props.cod_acesso,
      handleCodAcesso: props.handleCodAcesso,
      selectedAnexo: EmpresaStore.obs.empresa_edit.anexo,
      send_das: EmpresaStore.obs.empresa_edit.send_das,
      send_pgdas: EmpresaStore.obs.empresa_edit.send_pgdas,
      indicadorComparacao: EmpresaStore.obs.empresa_edit.indicadorComparacao
    };
  }

  handleChangeDasAuto = (e) => {
    const newValue = e.target.checked;
    this.setState({ send_das: newValue })
    EmpresaStore.obs.empresa_edit.send_das = newValue;
  };

  handleChangePgdDasAuto = (e) => {
    const newValue = e.target.checked;
    this.setState({ send_pgdas: newValue })
    EmpresaStore.obs.empresa_edit.send_pgdas = newValue;
  };

  changeIndicadorComparacao = (e) => {
    const newValue = e.target.checked;
    this.setState({ indicadorComparacao: newValue })
    EmpresaStore.obs.empresa_edit.indicadorComparacao = newValue;
  };

  render() {

    const handleFileChange = async (event) => {
      this.obs.validando = true;

      const file = event.target.files[0];

      this.obs.nome_certificado = file.name

      var cnpj = EmpresaStore.obs.empresa_edit.cnpj;

      var data = new FormData();
      data.append("filepgdas", file);
      data.append("cnpj", cnpj);

      let resp = await api.post("/api/upload-pgdas", data)

      if (resp.data.ok) {
        EmpresaStore.obs.existe_pdf_pgdas = true
        this.obs.nome_certificado = "Selecione um arquivo"

        toast.success('Arquivo importado com sucesso!', {});

        await EmpresaStore.load();

      } else {

        toast.error(resp.data.error, {});
      }

      this.obs.validando = false;

    };

    const handleButtonClick = () => {
      document.getElementById('fileInput').click();
    };

    return (

      <>

        <div style={{ width: 1000 }}>

          {!EmpresaStore.obs.empresa_edit.filial ?
            <>
              {EmpresaStore.obs.existe_pdf_pgdas ?
                <>
                  <MDBCol md="12">
                    <h3 className="info-cert">
                      Essa empresa possui uma PGDASD-DECLARAÇÃO.
                    </h3>
                  </MDBCol>

                  <MDBCol md="12">
                    <div style={{ display: "flex" }}>
                      <div>
                        <Button onClick={handleButtonClick} intent="danger">Alterar PGDAS</Button>
                        <input
                          id="fileInput"
                          type="file"
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                        />
                      </div>
                      <Button
                        style={{ marginLeft: 10 }}
                        icon="download"
                        onClick={this.state.handlesDownloadpgdas}
                      >
                        Visualizar PGDAS
                      </Button>
                    </div>
                  </MDBCol>

                  <br />
                  <Divider />
                  <br />

                  <MDBCol md="12">
                    <FormGroup label="Indicador de Comparação" labelInfo={<>
                      &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
                    </>
                    }>
                      <Switch
                        className="select-regras"
                        label={EmpresaStore.obs.empresa_edit.indicadorComparacao ? "Ativado" : "Desativado"}
                        checked={EmpresaStore.obs.empresa_edit.indicadorComparacao}
                        onChange={(e: any) => this.changeIndicadorComparacao(e)} />
                    </FormGroup>
                  </MDBCol>

                  <Divider />
                  <br />

                  <MDBCol md="12">
                    <Switch
                      label="Receber uma cópia dos arquivos DAS por E-mail"
                      alignIndicator="right"
                      checked={EmpresaStore.obs.empresa_edit.send_das}
                      onChange={(e: any) => this.handleChangeDasAuto(e)}
                      style={{ width: "max-content", fontWeight: "bold" }}
                    />
                  </MDBCol>

                  <br />

                  <MDBCol md="12">
                    <Switch
                      label="Receber uma cópia dos arquivos PGDAS-D por E-mail"
                      alignIndicator="right"
                      checked={EmpresaStore.obs.empresa_edit.send_pgdas}
                      onChange={(e: any) => this.handleChangePgdDasAuto(e)}
                      style={{ width: "max-content", fontWeight: "bold" }}
                    />
                  </MDBCol>
                  {(EmpresaStore.obs.empresa_edit.send_das || EmpresaStore.obs.empresa_edit.send_pgdas) ?

                    <MDBCol md="12">
                      <FormGroup
                        label=""
                        style={{ width: "60%" }}
                        helperText="Insira um e-mail para receber as cópias dos arquivos."
                      >
                        <InputGroup
                          type="text"
                          placeholder="email@email.com"

                          value={EmpresaStore.obs.empresa_edit.pgdas_email}
                          onChange={(e: any) => EmpresaStore.obs.empresa_edit.pgdas_email = e.target.value}>
                        </InputGroup>
                      </FormGroup>
                    </MDBCol>
                    : <br />}

                  <Divider />
                  <br />

                  <MDBCol md="12">
                    <Switch
                      label="Receber uma cópia dos arquivos DAS por WhatsApp"
                      alignIndicator="right"
                      checked={EmpresaStore.obs.empresa_edit.send_message_das}
                      onChange={(e: any) => EmpresaStore.obs.empresa_edit.send_message_das = e.target.checked}
                      style={{ width: "max-content", fontWeight: "bold" }}
                    />
                  </MDBCol>

                  <br />

                  <MDBCol md="12">
                    <Switch
                      label="Receber uma cópia dos arquivos PGDAS-D por WhatsApp"
                      alignIndicator="right"
                      checked={EmpresaStore.obs.empresa_edit.send_message_pgdas}
                      onChange={(e: any) => EmpresaStore.obs.empresa_edit.send_message_pgdas = e.target.checked}
                      style={{ width: "max-content", fontWeight: "bold" }}
                    />
                  </MDBCol>

                  {(EmpresaStore.obs.empresa_edit.send_message_das || EmpresaStore.obs.empresa_edit.send_message_pgdas) ? (<>
                    <MDBCol md="12">
                      <FormGroup helperText={`Pressione Enter a cada número informando para adicionar. Insira até ${this.obs.max_number_pgdas} números com DDD para receber as cópias dos arquivos.`}>
                        <PhoneNumberInput
                          value={typeof EmpresaStore.obs.empresa_edit.pgdas_numero == "string" ? [EmpresaStore.obs.empresa_edit.pgdas_numero] : EmpresaStore.obs.empresa_edit.pgdas_numero}
                          onChange={(phones) => EmpresaStore.obs.empresa_edit.pgdas_numero = phones}
                          maxPhones={this.obs.max_number_pgdas}
                          placeholder="+55 (11) 99999-9999"
                          disabled={false}
                        />
                      </FormGroup>
                    </MDBCol>
                  </>) : <br />}

                </>

                :

                <MDBCol md="12">
                  <FormGroup label="Selecionar arquivo PGDAS">
                    <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={handleFileChange} />
                  </FormGroup>
                </MDBCol>
              }

              <LoadingModal open={this.obs.validando} onClose={() => this.obs.validando = false} title={"Validando PGDAS"} />

            </>
            :
            <MDBCol>
              <h2 className="title">Exclusivo para Empresas Matriz</h2>
            </MDBCol>
          }

        </div>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`
          Indica se há a necessidade de comparação dos valores enviados na entrada com os valores calculados antes da transmissão.
        `} />

      </>
    );
  }
}
